module.exports = __webpack_public_path__ + "img/ttczzf-title.f6ed64d8.png";